(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    

	$('.main-cart .quantity button').click(function() {

		var plus = $(this).hasClass('plus');
		var minus = $(this).hasClass('minus');
		var index = $(this).attr('data');
		var quantity = parseInt($('.qty_' + index).val());

		if(plus == true) {
			quantity += 1;
		} else if(minus == true) {
			if(quantity > 0) {
				quantity -= 1;
			}
		}
		$('.qty_' + index).val(quantity);
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sections-faq"] && !Shopify.designMode) return;
  try {
    

  $('button.question').click(function() {
    var handle = $(this).attr('data');
    $('.answer-'+handle).slideToggle(150);
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_footer"]) return;
  try {
    

  // subnavigation
  $('footer nav button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('footer .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme_header"]) return;
  try {
    

  // display header search
  $('.microsearch').click(function() {
    $('.header_search').toggleClass('active');
    $('.header_search input').focus();
  });

  // hide header search
  $('.header_search button.close').click(function() {
    $('.header_search').removeClass('active');
    $('.header_search input').val('');
  });

  // display desktop sub navigation
  $('nav.desktop button.primary').click(function() {

    // get the button handle
    var handle = $(this).attr('data');

    // update button state
    // $(this).toggleClass('active');

    // hide open menus
    $('header ul ul.primary').each(function() {
      var state = $(this).css('display');
      console.log(state);
      var floating_handle = $(this).attr('data');
      if(state !== 'none') {
        $(this).slideToggle(150);
        // $('.button_'+floating_handle).toggleClass('active');
      } else {

        // open clicked menu
        $('.ul-desktop-' + handle).slideToggle(150);
      }
    });

    
  });

  // display desktop SUB sub navigation
  $('nav.desktop button.secondary').click(function() {

    // get the button handle
    var handle = $(this).attr('data');

    // update button state
    $(this).toggleClass('active');

    // open clicked menu
    $('.ul-desktop-' + handle).slideToggle(150);
  });

  // display mobile menu
  $('.navicon button').click(function() {

    $('header nav.mobile').toggleClass('active');
  });

  // mobile subnavigation
  $('header nav.mobile button').click(function() {

    // display child menu
    var handle = $(this).attr('data');
    $('header .ul-' + handle).slideToggle(150);

    // animate button "plus" icon
    $(this).toggleClass('active');
  });


  } catch(e) { console.error(e); }
})();
})();
